// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { carouselStyles } from "@ces/Overrides/Components/ProductCompareCarousel";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

carouselStyles.mainContainer = {
    gap: 0,
    css: css`
        margin: 0 1px;
    `,
};

carouselStyles.attributeWrapper = {
    css: css`
        margin-top: 40px;
        width: 100%;
        max-width: 100%;
    `,
};

carouselStyles.attributeContainer = {
    css: css`
        width: 100%;
        max-width: 100%;
        background-color: ${color("common.white")};
    `,
};

carouselStyles.attributeLabel = {
    as: "p",
    size: 15,
    weight: fontConfig.weight.bold,
    css: css`
        letter-spacing: 0;
        line-height: 20px;
        padding: 10px 10px 10px 15px;
        background: ${color("common.ui2")};
        min-height: 36px;
    `,
};

carouselStyles.attributeValueWrapper = {
    css: css`
        overflow: hidden;
        ${xScreen("lte", "xs")} {
            border-left: 0;
        }
    `,
};

carouselStyles.attributeValue = {
    as: "p",
    size: 15,
    css: css`
        letter-spacing: 0;
        line-height: 20px;
        min-height: 65px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    `,
};

carouselStyles.attributeValueText = {
    ellipsis: false,
};

carouselStyles.carouselCellGridItem = {
    width: 12,
};

carouselStyles.carousel = {
    container: {
        css: css`
            .swiper-horizontal > .xng-pagination-container {
                position: static;
                bottom: auto;
                left: auto;
                height: 20px;
                justify-content: center;
            }
        `,
    },
};
